
import ImageUploader from './ImageUploader.vue'

export default {
  name: 'MultiImageUploader',
  components: {
    ImageUploader
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    maxCount: {
      type: Number,
      default: 5
    },
    ratio: {
      type: String,
      default: '1:1'
    },
    purpose: {
      type: String,
      default: 'other'
    }
  },
  data () {
    return {
      localImages: [],
      dragIndex: null,
      dragOverIndex: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.localImages = val ? [...val] : []
      }
    }
  },
  methods: {
    emitChange () {
      this.$emit('input', [...this.localImages])
      this.$emit('change', [...this.localImages])
    },
    updateImage (index, url) {
      if (!url) return
      this.$set(this.localImages, index, url)
      this.emitChange()
    },
    removeImage (index) {
      this.localImages.splice(index, 1)
      this.emitChange()
    },
    addImage (url) {
      if (!url) return
      this.localImages.push(url)
      this.emitChange()
    },
    onDragStart (index) {
      this.dragIndex = index
    },
    onDragEnd () {
      this.dragIndex = null
      this.dragOverIndex = null
    },
    onDragOver (index) {
      this.dragOverIndex = index
    },
    onDrop (targetIndex) {
      const sourceIndex = this.dragIndex
      if (sourceIndex === null || sourceIndex === targetIndex) {
        this.dragIndex = null
        this.dragOverIndex = null
        return
      }

      // 创建新数组并重新排序
      const newArray = [...this.localImages]
      const item = newArray[sourceIndex]

      // 使用 filter 和 splice 来正确处理
      // 方法：先构建不含源元素的新数组，再插入到目标位置
      const filtered = newArray.filter((_, i) => i !== sourceIndex)
      filtered.splice(targetIndex, 0, item)

      this.localImages = filtered
      this.emitChange()
      this.dragIndex = null
      this.dragOverIndex = null
    }
  }
}
